// Shared Ignite Plan data — used by both the main /benefits/ignite-health
// page and the /ny outbound landing variant.

import {
    Video,
    HeartHandshake,
    Activity,
    Smartphone,
    Pill,
    ShieldCheck,
    Layers,
    CalendarClock,
    TrendingDown,
} from "lucide-react";

export const INCLUDED = [
    {
        icon: Video,
        t: "On-Demand Telemedicine",
        b: "24/7 access to licensed doctors by phone or video — no appointments, no waiting rooms.",
    },
    {
        icon: HeartHandshake,
        t: "Employee Assistance Program",
        b: "Confidential, around-the-clock support for emotional wellness, stress, family and relationship concerns, plus legal and financial advice.",
    },
    {
        icon: Activity,
        t: "Superpower Biomarker Testing",
        b: "Science-based insights across heart, hormone, metabolic, and immune health — over 100 biomarkers.",
    },
    {
        icon: Smartphone,
        t: "Ignite Health App",
        b: "One wellness hub — track fitness and nutrition goals and access expert resources anytime.",
    },
    {
        icon: Pill,
        t: "Prescription Drug Coverage",
        b: "1,200+ commonly used medications, fully covered at 70,000+ pharmacies nationwide.",
    },
    {
        icon: ShieldCheck,
        t: "Preventive Care & Women's Health",
        b: "Covered annual checkups, cancer and diabetes screenings, immunizations, mammograms, and pap smears.",
    },
];

export const FSA_EXAMPLES = [
    "Sunscreen & skincare",
    "Cold, flu & allergy meds",
    "Menstrual care",
    "Prenatal vitamins",
    "Breastfeeding supplies",
    "Copays & deductibles",
    "Therapy & mental health visits",
    "Blood pressure monitors",
    "Prescription glasses & contacts",
    "First aid & PPE",
];

export const EXISTING_PLAN = [
    {
        icon: Layers,
        t: "Complements, doesn't replace",
        b: "Ignite Health works alongside your current medical plan — same coverage, more support, greater value.",
    },
    {
        icon: CalendarClock,
        t: "Start mid-year",
        b: "No need to wait for renewal. Implementation is independent of your insurance renewal date.",
    },
    {
        icon: TrendingDown,
        t: "Reduce future claims",
        b: "More preventive care and earlier intervention typically means better outcomes and potentially lower claims over time.",
    },
];
